import { render, staticRenderFns } from "./register-biometry-success.vue?vue&type=template&id=61592f0f&"
import script from "./register-biometry-success.vue?vue&type=script&lang=js&"
export * from "./register-biometry-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports